import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import qs from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import ErrorPanel from 'components/ErrorPanel';
import { clearError } from 'store/user/actions';
import { errorSelector } from 'store/user/selectors';
import { checkIfTheTokenIsValid } from '../scenario-actions';
import '../sign-up-form.scss';

function EmailConfirmation() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const error = useSelector(errorSelector);
  const { token, username } = useMemo(() => qs.parse(search), [search]);
  const normalizedUsername = typeof username === 'string' ? username.replace(' ', '+') : '';
  const shouldCheckToken = Boolean(token && normalizedUsername);
  const localError = shouldCheckToken ? '' : 'Incorrect link';

  useEffect(() => {
    if (shouldCheckToken) {
      dispatch(
        checkIfTheTokenIsValid({
          token,
          username: normalizedUsername,
        }),
      );
    }
  }, [dispatch, normalizedUsername, shouldCheckToken, token]);

  useEffect(
    () => () => {
      if (error) {
        dispatch(clearError());
      }
    },
    [dispatch, error],
  );

  const handleErrorClose = () => {
    dispatch(clearError());
    history.replace('auth/sign-up');
  };

  return (
    <div className="form-container">
      {localError || error ? (
        <ErrorPanel
          type="warning"
          message={localError || error}
          buttonClickHandler={handleErrorClose}
          dataTestId="signup-email-confirmation-error"
        />
      ) : (
        <CircularProgress />
      )}
    </div>
  );
}

export default EmailConfirmation;
